var React = require('react');

function Line (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 12L19 12","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"}));
}

Line.defaultProps = {"width":"21","height":"24","viewBox":"0 0 21 24","fill":"none"};

module.exports = Line;

Line.default = Line;
